"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestDepartmentImage = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var IkeRestDepartmentImage = /** @class */ (function () {
    function IkeRestDepartmentImage(boundDepartment) {
        this.boundDepartment = boundDepartment;
    }
    IkeRestDepartmentImage.prototype.capture = function (imageData, metadata) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var core, headers, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        core = this.boundDepartment.boundUser.core;
                        headers = core.headers(this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);
                        headers[core_api_1.IkeRequestHeader.CONTENT_TYPE] = 'image/jpeg';
                        headers[core_api_1.IkeRequestHeader.REQUEST_ARGS] = JSON.stringify(metadata);
                        return [4 /*yield*/, core.fetch(core.path("/v1/action/capture.image.create"), { method: 'POST', body: imageData, headers: headers })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, core.validateIsJson(response)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response.json()];
                    case 3: return [2 /*return*/, core.handleError(response)];
                }
            });
        });
    };
    IkeRestDepartmentImage.prototype.image = function (uuid, imageData, zoom, collectedAt) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.capture(imageData, { type: 'image', zoom: zoom, collectedAt: collectedAt.toISOString(), uuid: uuid, metadata: undefined })];
            });
        });
    };
    return IkeRestDepartmentImage;
}());
exports.IkeRestDepartmentImage = IkeRestDepartmentImage;
//# sourceMappingURL=rest.department.image.js.map